import { Divider } from '@material-ui/core';

import { SBase, SText } from '@setvi/shared/components';

import { AISumContainer, useCustomTabelStyles } from './styled';

interface ProductSpecificationsProps {
  title: string;
  modalDescription?: string;
  onClose: () => void;
  name: string;
  attributes: {
    label: string;
    value: string;
  }[];
}

const ProductSpecifications = ({
  title,
  modalDescription,
  onClose,
  name,
  attributes
}: ProductSpecificationsProps) => {
  const classes = useCustomTabelStyles();

  return (
    <SBase
      header={{
        title,
        onClose,
        description: modalDescription
      }}
      width={700}
      style={{
        background: '#fff'
      }}
      disablePadding>
      <AISumContainer>
        <SText size="sm" style={{ color: '#5D7083' }}>
          Product Details
        </SText>
        <SText title={name} weight="semibold" noLineClamp size="md" />
        <Divider />
        <table className={classes.table}>
          <tr>
            <th>Name</th>
            <th>Value</th>
          </tr>
          {attributes.map(({ label, value }) => (
            <tr key={label}>
              <td width="45%">{label}</td>
              <td width="55%">
                <b>{value}</b>
              </td>
            </tr>
          ))}
        </table>
      </AISumContainer>
    </SBase>
  );
};

export default ProductSpecifications;
